import { render, staticRenderFns } from "./team-new-ux.vue?vue&type=template&id=9d088940&"
import script from "./team-new-ux.vue?vue&type=script&lang=js&"
export * from "./team-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d088940')) {
      api.createRecord('9d088940', component.options)
    } else {
      api.reload('9d088940', component.options)
    }
    module.hot.accept("./team-new-ux.vue?vue&type=template&id=9d088940&", function () {
      api.rerender('9d088940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/team-new-ux.vue"
export default component.exports